import { EVENT_STATUS } from "./enums";
var PriceguardPreprocessor = {
  preprocess(marketData, updatedMarketData, priceOldAfter = 30, ignoredPrices) {

    let processedDataObj = {
      data: [],
      notificationInfo: {
        newPricesCount: 0,
      },
    };

    processedDataObj.data = updatedMarketData.map((price) => {

      addPriceId(price);

      addPriceStatus(price, ignoredPrices, priceOldAfter);

      addUITimestamp(price);

      fixDecimalDigits(price);

      updateNotificationData(price, marketData, processedDataObj);

      return price;
      
    });

    return processedDataObj;

  },
};

export default PriceguardPreprocessor;

// Helper functions

function updateNotificationData(price, marketData, processedDataObj) {
  // Add this price to the list of new prices if it doesnt exist on the outdated data
  let isANewPrice = marketData.every((oldPrice) => oldPrice.id != price.id);
  if (isANewPrice) {
    if (price.status != EVENT_STATUS.IGNORE) {
      processedDataObj.notificationInfo.newPricesCount++;
    }
  }
}

function addPriceId(price) {
  price.id = price.name + price.identity + price.symbol;
}

function addPriceStatus(price, ignoredPrices, priceOldAfter) {
  let currentTime = new Date().getTime() / 1000
  var timePassed = Math.trunc((currentTime - price.lastUpdate));
  if (
    ignoredPrices != null &&
    ignoredPrices.length &&
    ignoredPrices.find((ignored) => ignored.id == price.id)
  ) {
    price.status = EVENT_STATUS.IGNORE;
  } else {
    if (price.priority > 0) {
      price.status = EVENT_STATUS.IMPORTANT;
    } else if (timePassed < priceOldAfter) {
      price.status = EVENT_STATUS.NEW;
    } else {
      price.status = EVENT_STATUS.OLD;
    }
  }
}

function fixDecimalDigits(price) {
  price.bid = price.bid.toFixed(price.digits);
  price.ask = price.ask.toFixed(price.digits);
}

function addUITimestamp(price) {
  price.client_timestamp = Date.now();
}
